/*
 * @Description: 获取native设备信息
 * @Author: wangbo16
 * @Date: 2021-08-24 10:43:49
 * @LastEditors: wangbo16
 * @LastEditTime: 2021-08-24 16:21:26
 */
import { useEffect } from 'react';
import ksBridge from '@ks/ks-bridge';
import { isInYoda } from '@utils/helpers';
import {
  Dispatch,
  RootState,
  useRematchDispatch,
  useRematchState
} from '@/store';
import { debugConsole } from '@aio/utils';

const mapState = (state: RootState) => ({
  statusBarHeight: state.common.statusBarHeight,
  cached: state.common.cached
});

const mapDispatch = (dispatch: Dispatch) => ({
  updateState: dispatch.common.updateState
});

const useDeviceInfo = (useCache = false) => {
  const { statusBarHeight, cached } = useRematchState(mapState);
  const { updateState } = useRematchDispatch(mapDispatch);

  // 获取设计像素的自适应布局像素
  const getAdaptiveCssPx = (width: number) => {
    return typeof width !== 'number' ? 0 : width * (window.innerWidth / 414);
  };

  useEffect(() => {
    if (isInYoda) {
      if (!useCache || !cached) {
        ksBridge.getDeviceInfo({
          success: (ret) => {
            if (ret.result === 1 && ret?.data?.statusBarHeight) {
              const newStatusBarHeight =
                ret.data.statusBarHeight / window.devicePixelRatio;
              debugConsole(
                `updateState statusBarHeight=${statusBarHeight} newStatusBarHeight=${newStatusBarHeight}`
              );
              updateState({
                statusBarHeight: newStatusBarHeight,
                cached: true
              });
            }
          },
          fail: (err) => {
            //
          }
        });
      }
    }
  }, []);

  return { statusBarHeight, getAdaptiveCssPx };
};

export default useDeviceInfo;
